import { RootState } from "core-integration/src/store";
import { getEntry } from "core-integration/src/store/entries/reducers";
import { getNextEvent } from "core-integration/src/store/events/reducers";
import { getRules } from "core-integration/src/store/game/reducers";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { ILoggedInPlayer } from "core-integration/src/store/player/types";
import CallToAction from "plos/src/components/CallToAction";
import HorizontalDivider from "plos/src/components/HorizontalDivider";
import ButtonLink from "plos/src/components/links/ButtonLink";
import SectionHeader from "plos/src/components/SectionHeader";
import { SurfaceContainer } from "plos/src/components/SurfaceContainer";
import { rightSidebarLayout } from "plos/src/layouts";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import HelmetHeadLeagues from "../../leagues/HelmetHeadLeagues";
import {
  gridDivider,
  leagueGridLayout,
  leaguesMainContent,
} from "../leaguesAndCups.css";

const Join = () => {
  const { t } = useTranslation("leaguesAndCups");
  const nxt = useSelector(getNextEvent);
  const rules = useSelector(getRules);
  const player = useSelector(
    (state: RootState) => getPlayerData(state) as ILoggedInPlayer,
  ); // enforced by EntryRoute
  const playerEntry = player.entry;
  const entry = useSelector((state: RootState) => getEntry(state, playerEntry));

  if (!rules || !entry) {
    return null;
  }

  return (
    <>
      <HelmetHeadLeagues />
      <div className={rightSidebarLayout}>
        <SurfaceContainer>
          <div className={leaguesMainContent}>
            <SectionHeader
              title={t("join.title", "Choose a League Type to Join")}
              description={
                t(
                  "join.description",
                  "You can join up to {{leagueJoinPrivateMax}} invitational leagues and {{leagueJoinPublicMax}} public leagues.",
                  {
                    leagueJoinPrivateMax: rules.league_join_private_max,
                    leagueJoinPublicMax: rules.league_join_public_max,
                  },
                ) as string
              }
            />
            <div className={leagueGridLayout}>
              <CallToAction
                heading={t(
                  "join.invitationalLeagues.heading",
                  "Invitational Leagues & Cups",
                )}
                description={t(
                  "join.invitationalLeagues.description",
                  "Join an invitational league and cup if somebody has given you a league code to enter.",
                )}
              >
                <ButtonLink to="private">
                  {t(
                    "join.invitationalLeagues.joinInvitationalLeagueButton",
                    "Join Invitational League & Cup",
                  )}
                </ButtonLink>
              </CallToAction>
              <div className={gridDivider}>
                <HorizontalDivider dataContent="or" />
              </div>
              <CallToAction
                heading={t("join.publicLeagues.heading", "Public Leagues")}
                description={t(
                  "join.publicLeagues.description",
                  "Join a public league to play against a small, randomly selected group of other game players.",
                )}
              >
                {nxt ? (
                  <ButtonLink to="public">
                    {t(
                      "join.publicLeagues.joinPublicLeagueButton",
                      "Join Public League",
                    )}
                  </ButtonLink>
                ) : (
                  <p>
                    <Trans
                      ns="leaguesAndCups"
                      i18nKey="join.publicLeagues.deadlinePassed"
                    >
                      It is no longer possible to join public leagues as the
                      last deadline has passed.
                    </Trans>
                  </p>
                )}
              </CallToAction>
            </div>
          </div>
        </SurfaceContainer>
      </div>
    </>
  );
};

export default Join;
